"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ImageGallery;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("react-rainbow-components/components/RenderIf"));

var _icons = require("@rainbow-modules/icons");

var _imagesUpload = _interopRequireDefault(require("./imagesUpload"));

var _images = _interopRequireDefault(require("./images"));

var _hooks = require("./hooks");

var _styled = require("./styled");

function ImageGallery(props) {
  var path = props.path,
      allowUpload = props.allowUpload,
      allowDelete = props.allowDelete,
      onSelect = props.onSelect,
      onError = props.onError,
      filter = props.filter,
      maxResults = props.maxResults;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      imagesUpload = _useState2[0],
      setImagesUpload = _useState2[1];

  var _useImageRefs = (0, _hooks.useImageRefs)({
    path: path,
    filter: filter,
    maxResults: maxResults,
    onError: onError
  }),
      _useImageRefs2 = (0, _slicedToArray2["default"])(_useImageRefs, 2),
      imageRefs = _useImageRefs2[0],
      setImageRefs = _useImageRefs2[1];

  var handleFileSeletorChange = function handleFileSeletorChange(images) {
    setImagesUpload(function (list) {
      return list.concat(Array.from(images));
    });
  };

  var handleUploaded = (0, _react.useCallback)(function (_ref) {
    var uploadedImage = _ref.uploadedImage,
        imageRef = _ref.imageRef;
    setImageRefs(function (list) {
      return [imageRef].concat((0, _toConsumableArray2["default"])(list));
    });
    setImagesUpload(function (list) {
      return list.filter(function (imageUpload) {
        return imageUpload !== uploadedImage;
      });
    });
  }, [setImageRefs]);

  var handleDeleteClick = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(imageRef) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return imageRef["delete"]();

            case 3:
              setImageRefs(imageRefs.filter(function (item) {
                return item.fullPath !== imageRef.fullPath;
              }));
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.log('Uh-oh, an error occurred!', _context.t0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));

    return function handleDeleteClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement(_styled.StyledContainer, null, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: allowUpload
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledFileContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.StyledFileSeletor, {
    value: null,
    onChange: handleFileSeletorChange,
    multiple: true,
    uploadIcon: /*#__PURE__*/_react["default"].createElement(_icons.Picture, null),
    variant: "multiline",
    accept: "image/*",
    bottomHelpText: "You can upload images up to 5MB "
  }))), /*#__PURE__*/_react["default"].createElement(_imagesUpload["default"], {
    path: path,
    list: imagesUpload,
    onUploaded: handleUploaded,
    onError: onError
  }), /*#__PURE__*/_react["default"].createElement(_images["default"], {
    allowDelete: allowDelete,
    list: imageRefs,
    onSelect: onSelect,
    onError: onError,
    onDelete: handleDeleteClick
  }));
}

ImageGallery.propTypes = {
  /** The path of the Storage e.g. `/users/u123/gallery` */
  path: _propTypes["default"].string.isRequired,

  /** Allow upload new image. */
  allowUpload: _propTypes["default"].bool,

  /** Allow delete new image. */
  allowDelete: _propTypes["default"].bool,

  /** The action triggered when an image is selected */
  onSelect: _propTypes["default"].func,

  /** The action triggered when some firebase storage error is return */
  onError: _propTypes["default"].func,

  /** This filter is applied to the images returned by firebase storage. */
  filter: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].func]),

  /** Is the maximum number of images to be displayed.. */
  maxResults: _propTypes["default"].number
};
ImageGallery.defaultProps = {
  allowUpload: false,
  allowDelete: false,
  onSelect: function onSelect() {},
  onError: function onError() {},
  filter: undefined,
  maxResults: 1000
};